import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Booking } from '../../models/orderModel';
import { AvailableParkings } from '../../models/orderModel';
import { Cart } from '../../models/CartModel';
import { BookingConfigService } from './booking-config.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CartService {
    cartPath = 'Shuttlebuss/Shuttlebuss.Service/cart';
    private hostPath: string;
    private orderIdSubject = new BehaviorSubject<string | null>(null);
    orderId$ = this.orderIdSubject.asObservable();

    constructor(public router: Router, private http: HttpClient, private bookingConfigService: BookingConfigService) {
        this.hostPath = JSON.parse(this.bookingConfigService.getConfig().IDENTITY);
    }

    public addOrder(order: Booking): Observable<Cart> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = `${this.hostPath}${this.cartPath}/addorder/`;
        return this.http
            .post<Cart>(url, order, { headers })
            .pipe(map(result => {
                return result;
            }),
                catchError(this.handleError)
            );
    }

    public getBooking3(organizationId: string, periodFrom: string, periodTo: string, discountCode: string): Observable<Booking> {
        const URL = `${this.hostPath}${this.cartPath}/booking3/${organizationId}/${periodFrom}/${periodTo}/${discountCode}`;
        return this.http.get<Booking>(URL).pipe(
            map(booking => {
                return booking;
            }),
            catchError(this.handleError)
        );
    }

    public getAvailableParkings(organizationId: string, periodFrom: string, periodTo: string, discountCode: string): Observable<AvailableParkings> {
        const URL = `${this.hostPath}${this.cartPath}/availableparkings/${organizationId}/${periodFrom}/${periodTo}/${discountCode}`;
        return this.http.get<AvailableParkings>(URL).pipe(
            map(booking => {
                return booking;
            }),
            catchError(this.handleError)
        );
    }

    public sendOrderConf(orderId: string): Observable<any> {
        const url = `${this.hostPath}${this.cartPath}/sendorderconf/${orderId}`;
        return this.http.get<any>(url).pipe(
            map(result => {
                return result;
            }),
            catchError(this.handleError)
        );
    }

    public abortorder(orderId: string): Observable<any> {
        const url = `${this.hostPath}${this.cartPath}/abortorder/${orderId}`;
        return this.http.get<any>(url).pipe(
            map(result => {
                return result;
            }),
            catchError(this.handleError)
        );
    }

    private handleError(error: Response | any) {
        const errMsg = error.message
            ? error.message
            : error.status
                ? `${error.status} - ${error.statusText}`
                : 'Server error';
        console.error(`cartService.handleError ${errMsg}`);
        return throwError(error);
    }

    setOrderId(id: string | null) {
        this.orderIdSubject.next(id);
    }

    getOrderId(): string | null {
        return this.orderIdSubject.value;
    }

}
